export default {
  page_title: '意见及查询',
  email: '阁下的电邮地址',
  comment: '阁下的意见及查询',
  success: '阁下的意见已成功提交。谢谢。',
  feedback: [
    'HKLII提供免费的法律资讯，并欢迎阁下就如何改善服务提出反馈，以及对HKLII服务作出鼓励。虽然HKLII的服务是免费提供，但我们依然会在资源允许的情况下，尽力保持最专业服务质素。',
    '请确保填写有效的电邮地址，以便我们向阁下发送回复。如没有填写</b> 有效的电邮地址，我们将无法回复。'
  ],
  disclaimers_tag: '免责声明',
  disclaimers: [
    '作为计算器科学家，我们旨在将法律资讯计算机化，并透过HKLII 的服务，令大众能获取免费法律资讯。我们不会也无法提供任何法律建议或回答有关法律的问题。',
    '阁下可以使用我们的搜索引擎来搜寻感兴趣的主题的关键词。如阁下需要更多有关搜索引擎使用上的协助，请随时于我们的意见页面与我们的团队联系。'
  ],
  close: 'HKLII 团队<br/>香港资讯科技及法律研究中心<br/>香港大学',
  ratetitle: '评价重制的 HKLII',
  rateintro: '在过去一年 HKLII 团队根据用家的反响改写了本网站的功能与界面。 希望阁下能拨冗填写问卷，使 HKLII 更为实用。',
  rate_nav: '导航清晰度',
  rate_interface: '界面效率',
  rate_search: '搜寻准确度',
  rate_data: '内容齐全',
  comments: '意见',
  comment_hint: '若你希望收到 HKLII 团队的回复或跟进调查，请将你的电邮地址一并填入意见格内。谢谢。',
}